import React, { useEffect } from 'react';

import { Formik } from 'formik';
import { connect } from 'react-redux';

import EnhancedForm2 from './EnhancedForm2';
import ScreenWrapper from '../../components/ScreenWrapper';

import validate from './validations2';
import initialValues from './initialValues2';
import { PAGES } from '../../config/constants';

import { saveToCRM } from '../../actions/saveToCRM.actions';

const ConsoleBrok2 = ({ setValues }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          marginBottom: 30,
        }}
      >
        A Few More Questions
      </h1>
      <ScreenWrapper fullWidth step={8}>
        <Formik
          initialValues={initialValues()}
          onSubmit={values => {
            setValues(values);
          }}
          validate={validate}
        >
          {formikProps => <EnhancedForm2 {...formikProps} />}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const mapState = state => {
  return {
    consoleBrok1: state.consoleBrok1,
  };
};

const mapDispatch = dispatch => {
  return {
    setPrevPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.CONSOLE_BROOK_1,
      });
    },

    setValues: values => {
      dispatch({
        type: 'SET_CONSOLE_BROK1',
        payload: values,
      });

      dispatch(saveToCRM());
    },
  };
};

export default connect(mapState, mapDispatch)(ConsoleBrok2);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/ConsoleBrok2.js